import requestTypes from 'constants/requestTypes'
import { fetchNext } from 'utils/request'
import { getCalendarUrl } from 'utils/endpoints'
import { CalendarResponse, CouponResponse } from './models/CalendarResponse'

const calendarUrl = getCalendarUrl()

export default class CalendarApi {
  static getHolidays = (startDate: string, endDate: string): Promise<any> => {
    const url = `/holidays?startDate=${startDate}&endDate=${endDate}`
    return fetchNext(requestTypes.GET, url, undefined, calendarUrl)
  }

  static getEconomicCalendar = (
    startDate: string,
    endDate: string,
    limit?: number,
    offset?: number
  ): Promise<CalendarResponse[]> => {
    let url = `/economic-calendar?startDate=${startDate}&endDate=${endDate}`

    if (limit) url += `&limit=${limit}`
    if (offset) url += `&offset=${offset}`
    return fetchNext(requestTypes.GET, url, undefined, calendarUrl)
  }

  static getCouponsPayments = (instrumentKey: string): Promise<CouponResponse> => {
    let url = `/coupons-payments?instrumentKey=${instrumentKey}&limit=100`
    return fetchNext(requestTypes.GET, url, undefined, calendarUrl)
  }
}
